import { lazy, Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-responsive-carousel/lib/styles/carousel.min.css";

import { setMobileView } from "./store/Common/CommonAction";
import PrivacyPolicy from "./components/common/PrivacyPolicy";
import { languageCurrentAction, languagePreferredAction } from "./store/Home/HomeAction";
import Contact from "./components/common/Contact";
import Media from "./components/common/Media";
import Devotions from "./screens/devotions/Devotions";
import CertificateDownload from "./screens/certificate/CertificateDownload";
import PageLoader from "./components/common/PageLoader";
import LoaderSpinner from "./components/common/LoaderSpinner";
import BookChapter from "./screens/verses/BookChapter";
import Journals from "./screens/journals/Journals";
import JournalDetails from "./screens/journals/JournalDetails";
import AuthorDetails from "./screens/journals/AuthorDetails";
import ChurchJournals from "./screens/churches/churchJournal.js";
import {
  clearGoogleTranslatePendingState,
  getGoogleTranslatePendingState,
  getStoredGoogleTranslateLanguage,
  GOOGLE_TRANSLATE_PAGE_LANGUAGE,
  GOOGLE_TRANSLATE_STATUS_EVENT,
  loadGoogleTranslateScript,
} from "./utils/googleTranslate";
const HomePage = lazy(() => import("./screens/home/HomePage"));
const Bible = lazy(() => import("./screens/bible/Bible.js"));

const LoginPage = lazy(() => import("./screens/login/LoginPage"));
const Curriculum = lazy(() => import("./screens/curriculum/Curriculum"));
const MyFavourites = lazy(() => import("./screens/myFavourites/MyFavourites"));
const Givings = lazy(() => import("./screens/givings/Givings"));
const Testimonials = lazy(() => import("./screens/testimonials/Testimonials"));
const VideoInfo = lazy(() => import("./components/common/VideoInfo"));
const SeeAll = lazy(() => import("./components/common/SeeAll"));
const MyProfile = lazy(() => import("./components/profileMenu/MyProfile"));
const MyDownloads = lazy(() => import("./components/profileMenu/MyDownloads"));
const GivingTwo = lazy(() => import("./components/givings/GivingTwo"));
const GivingPastList = lazy(() => import("./components/givings/GivingPastList"));
const About = lazy(() => import("./components/profileMenu/About"));
const LessonDetails = lazy(() => import("./components/curriculum/LessonDetails"));
const VideoPlayerContainer = lazy(() => import("./components/VideoPlayer/VideoPlayerContainer"));
const CategoryInfo = lazy(() => import("./components/common/CategoryInfo"));
const TestimonialInfo = lazy(() => import("./components/common/TestimonialInfo"));
const CurriculumDetailsV2 = lazy(() => import("./components/curriculum/CurriculumDetailsV2"));
const SessionExpired = lazy(() => import("./components/common/SessionExpired"));
const HelpAndSupport = lazy(() => import("./screens/support/HelpAndSupport"));
const Prayer = lazy(() => import("./screens/prayers/prayers.js"));
const Circle = lazy(() => import("./screens/circle/circle.js"));
const PlanDetails = lazy(() => import("./screens/circle/groupdetail.js"));
const IndPlanDetails = lazy(() => import("./screens/circle/individualgroupdetail.js"));
const StartPlanDetails = lazy(() => import("./screens/plans/PlanDetails.js"));
const FeatureChurch = lazy(() => import("./screens/churches/feature.js"));
const ChruchDetail = lazy(()=> import ("./screens/churches/churchdetail.js"));
const ChannelDetail = lazy(()=> import ("./screens/churches/churchdetail.js"));
const MinistryDetail = lazy(()=> import ("./screens/churches/churchdetail.js"));


const ChruchLocation = lazy(()=> import ("./screens/churches/location.js"));
const ChurchCarecell = lazy(()=> import ("./screens/churches/churchCarecell.js"));
const ChurchResource = lazy(()=> import ("./screens/churches/churchResource.js"));
const Church =lazy(()=>import("./screens/churches/church.js"))
const ChruchDetails =lazy(()=>import("./screens/churches/church1.js"))
const Chruch2 =lazy(()=>import("./screens/churches/church2.js"))
const Chruch3 =lazy(()=>import("./screens/churches/church3.js"))
const Chruch4 =lazy(()=>import("./screens/churches/church4.js"))
const Chruch5 =lazy(()=>import("./screens/churches/church5.js"))
const Chruch6 =lazy(()=>import("./screens/churches/Church6.js"))
const Channels =lazy(()=>import("./screens/channels/feature.js"))
const Ministry =lazy(()=>import("./screens/ministries/feature.js"))
const MinistryDeatils =lazy(()=>import("./screens/ministries/ministryDetail.js"))
const ChannelDeatils =lazy(()=>import("./screens/channels/channeldetails.js"))
const ChannelLocation =lazy(()=>import("./screens/channels/location.js"))
const Channel =lazy(()=>import("./screens/channels/channel.js"))
const Channe2 =lazy(()=>import("./screens/channels/channels2.js"))
const Showall =lazy(()=>import("./screens/churches/seeall.js"))
const OnBoard =lazy(()=>import("./screens/onboard/Onboarding.js"))
const MyTWG = lazy(() => import("./screens/mytwg/MyTWG.js"));
const Plans = lazy(() => import("./screens/plans/Plans.js"));





function App() {
  const dispatch = useDispatch();
  const { languageHeadings } = useSelector((state) => state.languageReducer.data);
  const [googleTranslateLoading, setGoogleTranslateLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 720) {
        dispatch(setMobileView(true));
      } else {
        dispatch(setMobileView(false));
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    const language_preferred = localStorage.getItem("language_preferred");
    if (language_preferred) {
      const currentLanguage = languageHeadings.filter(
        (item) => item.language_code === language_preferred
      );
      dispatch(languageCurrentAction(currentLanguage));
      dispatch(languagePreferredAction(language_preferred));
    } else {
      localStorage.setItem("language_preferred", "en");
      const currentLanguage = languageHeadings.filter((item) => item.language_code === "en");
      dispatch(languageCurrentAction(currentLanguage));
      dispatch(languagePreferredAction(language_preferred));
    }

    return window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    loadGoogleTranslateScript()
      .catch((error) => {
      });
  }, []);

  useEffect(() => {
    const pendingState = getGoogleTranslatePendingState();
    if (pendingState?.isTranslating) {
      setGoogleTranslateLoading(true);
    }

    const handleGoogleTranslateStatus = (event) => {
      setGoogleTranslateLoading(Boolean(event?.detail?.isTranslating));
    };

    window.addEventListener(GOOGLE_TRANSLATE_STATUS_EVENT, handleGoogleTranslateStatus);

    return () => {
      window.removeEventListener(GOOGLE_TRANSLATE_STATUS_EVENT, handleGoogleTranslateStatus);
    };
  }, []);

  useEffect(() => {
    if (!googleTranslateLoading) {
      return undefined;
    }

    let isCancelled = false;
    const translationStartedAt = Date.now();
    const intervalId = window.setInterval(() => {
      const pendingState = getGoogleTranslatePendingState();
      const storedLanguage = getStoredGoogleTranslateLanguage();
      const bodyClassList = document.body?.classList;
      const translationApplied =
        bodyClassList?.contains("translated-ltr") || bodyClassList?.contains("translated-rtl");
      const timedOut = Date.now() - translationStartedAt > 15000;

      if (
        !pendingState ||
        storedLanguage === GOOGLE_TRANSLATE_PAGE_LANGUAGE ||
        translationApplied ||
        timedOut
      ) {
        if (!isCancelled) {
          clearGoogleTranslatePendingState();
          setGoogleTranslateLoading(false);
        }
      }
    }, 400);

    return () => {
      isCancelled = true;
      window.clearInterval(intervalId);
    };
  }, [googleTranslateLoading]);

  return (
    <div className="web-app ">
      <div id="google_translate_element" className="google-translate-element" />
      {googleTranslateLoading && (
        <div className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-[2px] flex items-center justify-center">
          <div className="flex flex-col items-center gap-4 rounded-2xl bg-[#1F1F1F] px-8 py-7 shadow-2xl">
            <LoaderSpinner className="w-10 h-10 text-[#F8BA34]" />
            <p className="text-white text-sm md:text-base">Translating page...</p>
          </div>
        </div>
      )}
      <Suspense fallback={<PageLoader />}>
        <RouterProvider
          router={createBrowserRouter(
            createRoutesFromElements(
              <>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/logout" element={<SessionExpired />} />
                <Route path="/bible" element={<Bible />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/mytwg" element={<MyTWG />} />
                <Route path="/devotions" element={<Devotions />} />
                <Route path="/devotions/:id" element={<Devotions />} />
                <Route path="/curriculum" element={<Curriculum />} />
                <Route path="/curriculum-details/:id" element={<CurriculumDetailsV2 />} />
                <Route path="/lesson-details/:id/:index" element={<LessonDetails />} />
                <Route path="/favourites" element={<MyFavourites />} />
                <Route path="/givings" element={<Givings />} />
                <Route path="/testimonials" element={<Testimonials />} />
                <Route path="/videoInfo/:id" element={<VideoInfo />} />
                <Route path="/categoryInfo/:id" element={<CategoryInfo />} />
                <Route path="/testimonialInfo/:id" element={<TestimonialInfo />} />
                <Route path="/seeAll" element={<SeeAll />} />
                <Route path="/profile" element={<MyProfile />} />
                <Route path="/downloads" element={<MyDownloads />} />
                <Route path="/givings/comp" element={<GivingTwo />} />
                <Route path="/givings/past-list" element={<GivingPastList />} />
                <Route path="/about" element={<About />} />
                <Route path="/video-player" element={<VideoPlayerContainer />} />
                <Route path="/support" element={<HelpAndSupport />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/media" element={<Media />} />
                <Route path="/prayer" element={<Prayer />} />
                <Route path='/circle' element={<Circle/>}/>
                <Route path='/group/:id' element={<PlanDetails/>}/>
                <Route path='/plan/:id' element={<IndPlanDetails/>}/>
                <Route path='/plan/:id/start' element={<StartPlanDetails/>}/>
                <Route path='/plans' element={<Plans/>}/>

                <Route path='/churches' element={<FeatureChurch/>}/>
                <Route path='/church/:id' element={<ChruchDetail/>}/>
                <Route path='/onboarding' element={<OnBoard/>}/>

              
                <Route path='/all' element={<Showall/>}/>
                <Route path='/church' element={<Church/>}/>
                <Route path='/church2' element={<Chruch2/>}/>
                <Route path='/church3' element={<Chruch3/>}/>
                <Route path='/church4' element={<Chruch4/>}/>
                <Route path='/campus/:id/:campusid' element={<Chruch5/>}/>
                <Route path='/church6' element={<Chruch6/>}/>
                <Route path='/service/detail/:churchId/:serviceId' element={<ChruchDetails/>}/>
                <Route path='/church/location' element={<ChruchLocation/>}/> 
                <Route path="/certificate/:id" element={<CertificateDownload />} />
                <Route path="/chapter/:versionId/:bookId/:chapterNo" element={<BookChapter />} />
                <Route path='/channels' element={<Channels/>}/>
                <Route path='/channel1' element={<Channel/>}/>
                <Route path='/channel2' element={<Channe2/>}/>
                <Route path='/church/carecell/:id' element={<ChurchCarecell/>}/> 
                <Route path='/church/resource/:id' element={<ChurchResource/>}/> 
                <Route path='/channel/:id' element={<ChannelDeatils/>}/>
                <Route path='/channel/location' element={<ChannelLocation/>}/>
                <Route path='/ministry' element={<Ministry/>}/>
                <Route path='/ministry/:id' element={<MinistryDeatils/>}/>
                <Route path="/journals" element={<Journals />} />
                <Route path="/journals/:id" element={<JournalDetails />} />
                <Route path="/author/:id" element={<AuthorDetails />} />
                <Route path="/church/:churchId/journals" element={<ChurchJournals />} />



              </>
            )
          )}
        />
        <ToastContainer />
      </Suspense>
    </div>
  );
}

export default App;
